<template>
  <div v-loading="loading">
    <div class="detail_echart_con">
      <div class="table_header">
        <div class="table_header_title">Supply Chain</div>
        <div class="table_header_menus">
          <el-select
            clearable
            v-model="searchCompany"
            filterable
            class="search-select-con"
            popper-class="new-search-select"
            :popper-append-to-body="true"
            placeholder="Enter company name"
            @change="selectCompany"
            no-match-text="The Subject company has no affiliation with the inquired company."
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.aaaId"
            >
              <OverflowTooltip :tip="item.name" />
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="detail_echart_con_box">
        <!--关系图左边表格  -->
        <div class="ownership-graph-left">
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Major Clients</div>
            <div
              class="ownership-graph-left-desc link_text"
              @click="showDetaiils('Major Clients', 1)"
            >
              {{ supplyChainList.customerCount }}
            </div>
          </div>
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Major Suppliers</div>
            <div
              class="ownership-graph-left-desc link_text"
              @click="showDetaiils('Major Suppliers', 2)"
            >
              {{ supplyChainList.supplierCount }}
            </div>
          </div>
          <!-- <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Major Markets</div>
            <div class="ownership-graph-left-desc">171</div>
          </div> -->
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Banking</div>
            <div class="ownership-graph-left-desc">
              {{ supplyChainList.bankCount }}
            </div>
          </div>
          <!-- <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Related Party Transa</div>
            <div class="ownership-graph-left-desc">7</div>
          </div> -->
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Total Sales</div>
            <div class="ownership-graph-left-desc">
              {{ supplyChainList.sellTotal | FilterNum }}
            </div>
          </div>
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Total Purchasing</div>
            <div class="ownership-graph-left-desc">
              {{ supplyChainList.purchaseTotal | FilterNum }}
            </div>
          </div>
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Active Players</div>
            <div class="ownership-graph-left-desc">
              {{ supplyChainList.activeEnterprisesInIndustry | FilterNum }}
            </div>
          </div>
          <div class="ownership-graph-left-item flex-center-start">
            <div class="ownership-graph-left-name">Main Products/Servic</div>
            <div class="ownership-graph-left-desc">
              <!-- {{ supplyChainList.mainServicesAndProducts }} -->
              <OverflowTooltip
                :tip="supplyChainList.mainServicesAndProducts"
                :lineClamp="2"
              />
            </div>
          </div>
        </div>
        <!-- 关系图 -->
        <div class="detail_echart_d3">
          <SupplyChain
            ref="echartRef"
            :relationshipSearch="relationshipSearch"
            :detailInfo="detailInfo"
            @getCompanyList="onGetCompanyList"
          />
        </div>
      </div>
    </div>
    <div class="detail_echart_table" v-if="tableDataDetail.entname != ''">
      <div class="table_header_title margin-bottom20">
        {{ tableDataDetail.entname }}
        <i class="iconfont icon-cuowu" @click="closeDetailTable" />
      </div>
      <el-table
        class="risk_table"
        :data="tableDataDetail.childrens"
        height="100%"
        ref="tableRef"
        :row-key="(row) => row.aaaId"
      >
        <el-table-column label="#" align="center" width="120" type="index">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="Company Name"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="flex_center_start_box">
              <span class="link_hover_text" @click="goDetail(scope.row)">
                {{ scope.row.companyName || "-" }}</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="totalTransactions"
          label="Total Trading Volume"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="ratioRounded"
          align="center"
          label="Transaction/Total (%)"
          min-width="120"
        >
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <Page
          keyword="Supply Chain"
          :fontColor="'#B44818'"
          :total="total"
          :pageSize="searchParams.pageSize"
          :currentPage="searchParams.currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>
    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import EquityD3 from "@/views/company/details/Background/componet/index.vue";
import SupplyChain from "./Com_SupplyChain-echart.vue";
import Tips from "@/views/newLayout/tips.vue";
import {
  getSuspectedCustomerList,
  getRelationshipInquiryOfSusp,
  getBusinessChain,
} from "@/api/uboApi.js";
import {
  formatterTxt,
  formatListMax50,
} from "@/views/company/details/Background/utils";

export default {
  name: "UboDetail2",
  mixins: [mixins1],
  components: {
    Page,
    EquityD3,
    Tips,
    SupplyChain,
  },
  props: {
    detailInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      isShowTips: false,
      isShowD3: false,
      total: 0,
      searchParams: {
        currentPage: 1,
        pageSize: 10,
      },

      tableDataDetail: {
        entname: "",
        type: 1, //1：aaaid为采购商；2：aaaid为供应商
        childrens: [],
      },

      searchCompany: "",
      companyList: [],
      supplyChainList: {
        customerCount: "-",
        supplierCount: "-",
        bankCount: "-",
        sellTotal: "-",
        purchaseTotal: "-",
        activeEnterprisesInIndustry: "-",
        mainServicesAndProducts: "-",
      },
      relationshipSearch: {
        recent: "-",
        trade: "-",
        indusyry: "-",
        topList: [],
      },
    };
  },
  methods: {
    changeSwitch(val) {
      this.isShowD3 = val;
    },
    onChangePage(param) {
      this.searchParams.currentPage = param.page;
      this.searchParams.pageSize = param.pageSize;
      this.showDetaiils(
        this.tableDataDetail.entname,
        this.tableDataDetail.type,
      );
    },
    showDetaiils(name, type) {
      this.tableDataDetail.entname = name;
      this.tableDataDetail.type = type;
      // this.tableDataDetail.childrens = this.tableData;
      let param = {
        aaaid: this.$route.query.id3a,
        type: this.tableDataDetail.type,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
      };
      getSuspectedCustomerList(param)
        .then((res) => {
          if (res.code == 200) {
            this.tableDataDetail.childrens = res.data.rows;
            this.total = res.data.total;
          }
        })
        .catch((err) => {});

      this.$nextTick(() => {
        document.querySelector(".content_wrap").scrollTop = 9999;
      });
    },
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.aaaid,
          keyword: row.companyName,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 关闭
    closeDetailTable() {
      this.tableDataDetail = {
        entname: "",
        type: 1,
        childrens: [],
      };
    },
    // 查询供应链业务链穿透
    getBusinessChainApi() {
      let params = {
        aaaid: this.$route.query.id3a,
      };
      getBusinessChain(params).then((res) => {
        if (res.code == 200) {
          this.supplyChainList = {
            customerCount: res.data.customerCount || "-",
            supplierCount: res.data.supplierCount || "-",
            bankCount: res.data.bankCount || "-",
            sellTotal: res.data.sellTotal || "-",
            purchaseTotal: res.data.purchaseTotal || "-",
            activeEnterprisesInIndustry:
              res.data.activeEnterprisesInIndustry || "-",
            mainServicesAndProducts: res.data.mainServicesAndProducts || "-",
          };
        }
      });
    },
    // 获取公司列表
    onGetCompanyList(companyList) {
      const map = new Map();

      const result = companyList.filter((item) => {
        if (!map.has(item.aaaId)) {
          map.set(item.aaaId, true);
          return true;
        }
        return false;
      });
      this.companyList = result;
    },
    // 查询关系
    async getRelationshipApi(node) {
      let params = {
        targetCompany: this.$route.query.id3a,
        queriedCompany: node.aaaId,
        type: 1, //1：供应商 2：采购商
      };
      let res = await getRelationshipInquiryOfSusp(params);

      if (res.code == 200) {
        this.relationshipSearch = {
          recent: res.data.suspectedData[0].recentTradeDate || "-",
          trade: res.data.suspectedData[0].tradeRelatedCompanies || "-",
          indusyry: res.data.suspectedData[0].industryName || "-",
          topList: res.data.suspectedData[0].tradeRelatedProduct || [],
        };
      }
    },

    // 查询公司
    selectCompany(val) {
      const selectedNode = this.companyList.find((node) => node.aaaId === val);
      console.log("Selected Node:", selectedNode);
      if (selectedNode) {
        this.getRelationshipApi(selectedNode).then(() => {
          this.$refs.echartRef.ishowSearchDetail = true;
        });
      }
    },
  },
  mounted() {
    this.getBusinessChainApi();
  },
};
</script>
<style scoped>
.ownership_box {
  background-color: #f5f5f5;
}

.ownership-graph-left {
  width: auto;
  height: auto;
  margin-right: 200px;
}
.ownership-graph-left-item {
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #cccccc;
}
.ownership-graph-left-item:first-child {
  border-top: 1px solid #cccccc;
}
.ownership-graph-left-name {
  width: 280px;
  height: 100%;
  padding-left: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  background: #f3f3f3;
}
.ownership-graph-left-desc {
  width: 260px;
  line-height: 22px;
  font-size: 18px;
  text-align: center;
}
.icon-cuowu {
  float: right;
  color: #1a2332;
  font-size: 26px;
  cursor: pointer;
}
.link_text {
  color: #b44818;
  cursor: pointer;
}

@media (max-width: 1920px) {
  .ownership-graph-left {
    margin-right: 140px;
  }
  .ownership-graph-left-item {
    height: 60px;
    line-height: 60px;
  }
  .ownership-graph-left-name {
    width: 186px;
    padding-left: 14px;
    font-size: 16px;
  }
  .ownership-graph-left-desc {
    width: 173px;
    line-height: 16px;
    font-size: 16px;
  }
  .icon-cuowu {
    font-size: 22px;
  }
}
</style>
